import { t } from "i18next"

import { DISTRIBUTION_ERROR_MESSAGES } from "./constants"
import { getBalanceApi } from "./get-balance"

import type { ExecuteDistributionRequest, ExecuteDistributionResponse } from "./types"

type DistributionErrorStatus = keyof typeof DISTRIBUTION_ERROR_MESSAGES

const isMappedDistributionErrorStatus = (status: number): status is DistributionErrorStatus =>
  status in DISTRIBUTION_ERROR_MESSAGES

export const createBalanceApi = getBalanceApi.injectEndpoints({
  endpoints: builder => ({
    executeDistribution: builder.mutation<ExecuteDistributionResponse, ExecuteDistributionRequest>({
      query: body => ({
        url: "/api/v1/balance/group-distribution/execute",
        method: "POST",
        body
      }),
      transformErrorResponse: response => {
        const entry =
          typeof response.status === "number" && isMappedDistributionErrorStatus(response.status)
            ? DISTRIBUTION_ERROR_MESSAGES[response.status]
            : { key: "distribution-error", fallback: "Distribution failed" }
        return {
          status: "CUSTOM_ERROR" as const,
          httpStatus: response.status,
          error: t(entry.key, entry.fallback),
          data: "data" in response ? response.data : undefined
        }
      },
      invalidatesTags: (_result, error) => (error ? [] : ["Balance", "DistributionChats"])
    })
  })
})

export const { useExecuteDistributionMutation } = createBalanceApi
